import { useEffect, useState } from 'react'

const useDeferredInitialLoad = () => {
    const [isReady, setIsReady] = useState(false)

    useEffect(() => {
        let animationFrameId: number | undefined
        let timeoutId: number | undefined

        const scheduleReady = () => {
            timeoutId = window.setTimeout(() => setIsReady(true), 0)
        }

        if (typeof window.requestAnimationFrame === 'function') {
            animationFrameId = window.requestAnimationFrame(scheduleReady)
        } else {
            scheduleReady()
        }

        return () => {
            if (animationFrameId !== undefined && typeof window.cancelAnimationFrame === 'function') {
                window.cancelAnimationFrame(animationFrameId)
            }
            if (timeoutId !== undefined) window.clearTimeout(timeoutId)
        }
    }, [])

    return isReady
}

export default useDeferredInitialLoad
